'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var constants = require('./constants.js');
var tooltip = require('../utils/tooltip.js');

var generateTitle = function (innerTitle, subTitle, titlePosition, titleColor, subTitleColor) {
    if (innerTitle) {
        var color1 = titleColor || '#4C506C';
        var color2 = subTitleColor || '#6E84A3';
        return "<div style=\"text-align: center; margin-top: " + (titlePosition || '-7rem') + ";\">\n  <p style=\"font-size: 4rem; color: " + color1 + "; font-family: TT Commons,Arial,sans-serif;font-weight: 400;\">\n    " + innerTitle + "\n  </p>\n  <p style=\"font-size: 0.95rem;color: " + color2 + "; font-family: TT Commons,Arial,sans-serif;font-weight: 500;margin-top: -4.5rem\">\n    " + subTitle + "\n  </p>\n</div>";
    }
    return '';
};
var generatePane = function (backgroundColor, innerRadius, outerRadius) {
    constants.pane.background[0].backgroundColor = backgroundColor;
    return tslib.__assign(tslib.__assign({}, constants.pane), { background: [
            tslib.__assign(tslib.__assign({}, constants.pane.background[0]), { innerRadius: innerRadius + "%", outerRadius: outerRadius + "%" }),
        ] });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var generateSeries = function () { return [
    {
        borderColor: '#000',
        enableMouseTracking: false,
        dataLabels: {
            borderColor: 'white',
            enabled: true,
            useHTML: true,
            style: {
                color: 'black',
                width: '150px',
                border: 'none',
            },
            format: "",
        },
        data: [
            {
                color: 'rgba(48,104,253,1)',
                radius: '100%',
                innerRadius: '85%',
                y: 35,
                lineCap: 'round',
            },
        ],
    },
]; };
var generateOptions = function (options) {
    var backgroundColor = options.backgroundColor, height = options.height, series = options.series, tooltipFormatter = options.tooltipFormatter, innerRadius = options.innerRadius, outerRadius = options.outerRadius;
    return {
        chart: tslib.__assign(tslib.__assign({}, constants.chartType), { height: height }),
        title: constants.title,
        credits: constants.credits,
        pane: generatePane(backgroundColor, innerRadius, outerRadius),
        yAxis: constants.yAxis,
        plotOptions: constants.plotOptions,
        series: series,
        tooltip: {
            formatter: function () {
                return tooltip.xOnlyChart(this, tooltipFormatter);
            },
        },
    };
};

exports.generateOptions = generateOptions;
exports.generatePane = generatePane;
exports.generateSeries = generateSeries;
exports.generateTitle = generateTitle;
